/** Default sort used by the course catalog import list screen (client-side only). */
export const IMPORT_COURSE_LIST_DEFAULTS = {
  sortBy: 'name',
  sortDir: 'asc',
};

/** Sort keys exposed by the import course table column headers. */
export const IMPORT_COURSE_SORT_FIELDS = {
  name: 'name',
  email: 'email',
};

/**
 * Computes the next client-side sort when a column header is clicked.
 * Same column toggles asc/desc; a new column always starts asc.
 */
export function getNextImportCourseSort(columnKey, currentSortBy, currentSortDir) {
  const sortBy = columnKey || IMPORT_COURSE_LIST_DEFAULTS.sortBy;
  if (currentSortBy === sortBy) {
    return {
      sortBy,
      sortDir: currentSortDir === 'asc' ? 'desc' : 'asc',
    };
  }
  return { sortBy, sortDir: 'asc' };
}

/** Resolves a row field value for client-side column sorting. */
function importCourseSortValue(row, sortBy) {
  switch (sortBy) {
    case IMPORT_COURSE_SORT_FIELDS.email:
      return row.email ?? '';
    case IMPORT_COURSE_SORT_FIELDS.name:
    default:
      return row.name || row.email || '';
  }
}

/**
 * Sorts import course rows in memory — no API round-trip.
 */
export function sortImportCoursesLocally(rows, sortBy, sortDir) {
  const list = Array.isArray(rows) ? [...rows] : [];
  const dir = sortDir === 'desc' ? -1 : 1;
  const field = sortBy || IMPORT_COURSE_LIST_DEFAULTS.sortBy;

  list.sort((a, b) => {
    const av = importCourseSortValue(a, field);
    const bv = importCourseSortValue(b, field);
    return String(av).localeCompare(String(bv), undefined, { sensitivity: 'base' }) * dir;
  });

  return list;
}
